<template>
  <div class="homeWrapper">
    <!-- header -->
    <Header />

    <!-- home_pc -->
    <div class="home_pc">
      <!-- 走马灯-幻灯片 -->
      <div class="home_carousel">
        <Carousel
          autoplay
          arrow="always"
          v-model="showIndex"
          :autoplay-speed="autoplaySpeed"
          loop
        >
          <CarouselItem v-for="(item, index) in bannerArr" :key="index">
            <div class="carousel-img">
              <img :src="origin + item.imgUrl" width="100%" alt="深圳市同为装饰设计工程有限公司" />
            </div>
          </CarouselItem>
        </Carousel>

        <!-- 控制区 -->
        <div class="carousel_arrow"></div>
      </div>

      <!-- 项目 -->
      <div class="product">
        <!-- 背景 -->
        <div class="pro_top">
          <div class="pro_t_right"></div>
        </div>
        <div class="pro_bottom">
          <div class="pro_b_l_line"></div>
          <div class="pro_b_b_line"></div>
        </div>

        <!-- 内容 -->
        <Carousel arrow="always" v-model="showIndex2" loop dots="none">
          <CarouselItem v-for="(item, index) in allProjectList" :key="index">
            <router-link :to="{name: 'ProjectDetail', params: {id: item.id}}">
              <div class="pro_main clearfix">
                <div class="pro_left">
                  <p>
                    {{item.nameEn}}
                    <br />
                    <span>{{item.nameCn}}</span>
                  </p>
                  <em></em>
                </div>
                <div class="pro_right">
                  {{item.remarks}}
                </div>
              </div>
              <!-- 图片 -->
              <div class="pro_photo">
                <img :src="origin + (item.imgUrl.split('|')[0])" :alt="item.nameCn" />
              </div>
              <!-- 探索详情 -->
              <div class="explore">
                <a href="#">
                  探索详情
                  <i class="iconfont icon-arrow-right-ico"></i>
                </a>
              </div>
              <div class="box_shadow">
                <img src="~@/assets/images/shadow_bg.png" alt />
              </div>
            </router-link>
          </CarouselItem>
        </Carousel>
      </div>

      <!-- 案例中心 -->
      <div class="case_center">
        <div class="case_content w1200">
          <div class="case_title clearfix">
            <div class="title">
              <img
                src="~@/assets/images/title_case.png"
                alt="案例中心"
                width="199"
              />
            </div>
            <router-link to="/project">
              查看所有
              <i class="iconfont icon-arrow-right-ico"></i>
            </router-link>
          </div>
          <div class="case_panel clearfix">
            <dl v-for="(item, index) in caseCenterList" :key="index">
              <router-link
                :to="{ name: 'Project', params: { index } }"
                target="_blank"
              >
                <dt>
                  <img :src="origin + item.imgUrl" :alt="item.nameCn" />
                </dt>
                <dd>
                  {{item.nameEn}}
                  <br />
                  <span>{{item.nameCn}}</span>
                </dd>
              </router-link>
            </dl>
          </div>
        </div>
        <!-- case_bg -->
        <div class="case_top_bg"></div>
        <div class="case_bottom_bg"></div>
      </div>

      <!-- 合作伙伴 -->
      <div class="partner">
        <div class="case_content w1200">
          <div class="case_title clearfix">
            <div class="title">
              <img
                src="~@/assets/images/title_hzhb.png"
                alt="合作伙伴"
                width="195"
              />
            </div>
            <router-link to="/customer">
              查看详情
              <i class="iconfont icon-arrow-right-ico"></i>
            </router-link>
          </div>
          <ul class="partner_panel clearfix">
            <li v-for="(item, index) in cooperationList.slice(0, 10)" :key="index">
              <router-link to="/customer">
                <img :src="origin + item.imgUrl" :alt="item.name" />
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- home_mobile -->
    <div class="home_mobile">
      <!-- mobile_banner -->
      <div class="mobile_banner">
        <!-- Swiper -->
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in bannerArr" :key="index">
              <img :src="origin + item.imgUrl" width="100%" alt="深圳市同为装饰设计工程有限公司" />
            </div>
          </div>
          <!-- Add Arrows -->
          <div class="swiper-button-next">
            <i class="iconfont icon-arrow-right-ico"></i>
          </div>
          <div class="swiper-button-prev">
            <i class="iconfont icon-fanhui"></i>
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>
        </div>
      </div>

      <!-- item_swiper -->
      <div class="item_swiper">
        <div class="item_top">
          <div class="item_r_line"></div>
          <div class="item_b_line"></div>
        </div>
        <div class="item_main">
          <!-- Swiper -->
          <div class="swiper-container">
            <div class="swiper-wrapper">
              
              <dl class="swiper-slide" v-for="(item, index) in allProjectList.slice(0, 10)" :key="index">
                <router-link :to="{name: 'ProjectDetail', params: {id: item.id}}">
                  <dt>
                    <span>{{item.nameEn}}</span> <br />{{item.nameCn}}
                  </dt>
                  <dt>
                    <img :src="origin + (item.imgUrl.split('|')[0])" :alt="item.nameCn" style="height: 220px;" />
                  </dt>
                  <dt>
                    <img src="~@/assets/images/shadow_bg.png" :alt="item.nameCn" width="100%" />
                  </dt>
                  <dd>
                    {{item.remarks}}
                  </dd>
                </router-link>
              </dl>
            </div>
            <!-- Add Arrows -->
            <div class="swiper-button-next" style="display: none">
              <i class="iconfont icon-arrow-right-ico"></i>
            </div>
            <div class="swiper-button-prev" style="display: none">
              <i class="iconfont icon-fanhui"></i>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>

      <!-- 案例中心 -->
      <div class="case_center">
        <div class="case_content">
          <div class="case_title clearfix">
            <div class="title">
              <img src="~@/assets/images/title_case.png" alt="案例中心" />
            </div>
            <router-link to="/project">
              查看所有
              <i class="iconfont icon-arrow-right-ico"></i>
            </router-link>
          </div>

          <!-- case_main -->
          <div class="case_main">
            <div class="case_top clearfix">
              <dl v-for="(item, index) in caseCenterList" :key="index">
                <router-link
                  :to="{ name: 'Project', params: { index } }"
                  target="_blank"
                >
                  <dt>
                    <img :src="origin + item.imgUrl" :alt="item.nameCn" />
                  </dt>
                  <dd>{{item.nameEn}}<br />{{item.nameCn}}</dd>
                </router-link>
              </dl>
            </div>
          </div>
        </div>
        <!-- case_bg -->
        <div class="case_top_bg"></div>
        <div class="case_bottom_bg"></div>
      </div>

      <!-- 合作伙伴 -->
      <div class="teamwork">
        <div class="case_title clearfix">
          <div class="title">
            <img src="~@/assets/images/title_hzhb.png" alt />
          </div>
          <router-link to="/customer">
            查看详情
            <i class="iconfont icon-arrow-right-ico"></i>
          </router-link>
        </div>

        <ul class="partner_panel clearfix">
          <li v-for="(item, index) in cooperationList.slice(0, 9)" :key="index">
            <router-link to="/customer">
              <img :src="origin + item.imgUrl" :alt="item.name" />
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- footer -->
    <Footer />
  </div>
</template>

<script>
import { HomeBanner, HomeAllProject, HomeCaseCenter, HomeCooperation } from "@/api/http";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Vue from "vue";
import { Carousel, CarouselItem } from "iview";
Vue.component("Carousel", Carousel);
Vue.component("CarouselItem", CarouselItem);
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  name: "home",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      showIndex: 0,
      showIndex2: 0,
      autoplaySpeed: 5000,
      bannerImg: require("@/assets/images/banner1.png"),
      img1: require("@/assets/images/pro1.png"),
      bannerImg_mobile: require("@/assets/images/banner_mobile1.png"),
      mobile_case1: require("@/assets/images/mobile_case1.png"),
      mobile_case2: require("@/assets/images/mobile_case2.png"),
      mobile_case3: require("@/assets/images/mobile_case3.png"),
      mobile_case4: require("@/assets/images/mobile_case4.png"),
      mobile_item: require("@/assets/images/mobile_item.png"),

      origin: '', // 域
      bannerArr: [],   // banner数据
      allProjectList: [], // 所有项目数据
      caseCenterList: [], // 案例中心数据
      cooperationList: [],  // 合作伙伴数据
    };
  },
  created() {

    // 获取移动端promise-swiper
    if(this.mobileDevice()) {
      this.promiseData();

      // 案例中心--分平台
      this.getHomeCaseCenter('app');
    }else{
      // banner加载
      this.getBanner('pc');
      
      // 所有项目数据
      this.getHomeAllProject();

      // 案例中心--分平台
      this.getHomeCaseCenter('pc');
    }

    // 获取合作伙伴
    this.getHomeCooperation();

  },
  mounted() {
    /*
    var swiper = new Swiper(".swiper-container", {
      cssMode: true,
      loop: true,
      spaceBetween: 5,
      nextButton: ".swiper-button-next",
      prevButton: ".swiper-button-prev",
      pagination: ".swiper-pagination",
      paginationClickable: true,
      mousewheel: true,
      keyboard: true,
    });
    */
  },
  methods: {

    // 获取异步数据
    promiseData() {
      Promise.all([HomeBanner('app'), HomeAllProject()]).then((res) => {
        // console.log(res);
        if(res[0].status == 200) {
          this.origin = this.$origin;
          this.bannerArr = res[0].data;

          if (res[1].status == 200) {
            this.origin = this.$origin;
            this.allProjectList = res[1].data;
          }
        }
        // 在获取完数据后，将swiper放在$nextTick下一个UI帧再初始化。
        this.$nextTick(() => {
          this.initSwiper();
        });
      })
      .catch((err) => {
        console.log(err)
      })
    },

    // 初始化swiper
    initSwiper() {
      var swiper = new Swiper('.swiper-container', {
        cssMode: true,
        loop: true,
        autoHeight: 'auto',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        pagination: '.swiper-pagination',
        paginationClickable: true,
        mousewheel: true,
        keyboard: true,
      })
    },

    // 获取banner数据方法
    getBanner(platform) {
      HomeBanner(platform)
      .then(res => {
        // console.log(res);
        this.origin = this.$origin;
        this.bannerArr = res.data;
        
        // 在获取完数据后，将swiper放在$nextTick下一个UI帧再初始化。
        // if(this.mobileDevice()) {
        //   this.$nextTick(() => {
        //     this.initSwiper();
        //   });
        // }
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },

    // 所有项目数据
    getHomeAllProject() {
      HomeAllProject()
      .then(res => {
        // console.log(res);
        this.origin = this.$origin;
        this.allProjectList = res.data;
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },

    // 获取案例中心
    getHomeCaseCenter(platform) {
      HomeCaseCenter(platform)
      .then(res => {
        // console.log(res);
        this.origin = this.$origin;
        this.caseCenterList = res.data.reverse();
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },

    // 获取合作伙伴
    getHomeCooperation() {
      HomeCooperation()
      .then(res => {
        // console.log(res);
        this.origin = this.$origin;
        this.cooperationList = res.data;
      })
      .catch(err => {
        console.log('数据加载失败，请稍后重试');
      })
    },

    // 判断移动设备
    mobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/home";
</style>
